import { Component, OnInit } from '@angular/core';
import { Configuration } from 'src/app/app.constants';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  currentUser = 0;
  databaseRedirectUrl;
  CCIRedirectUrl;
  isDropdownOpen = false;


  constructor(private configuration: Configuration,private router: Router) {
    this.databaseRedirectUrl =   this.configuration.SERVER.databaseRedirectUrl;
    this.CCIRedirectUrl =   this.configuration.SERVER.CCIRedirectUrl;
   }

  ngOnInit() {
  }

  goToSection(sectionId: string) {
  this.isDropdownOpen = false;

  this.router.navigate(['/home'], {
    fragment: sectionId
  });
}
}
